import { Context, Category } from "./HomePage";

// Default habits
export const defaultHabits = [
  { id: 1, name: "Workout", score: 10, archived: false, note: "30 minutes minimum", streakEnabled: true, allowSkip: true, weeklyBonus: true },
  { id: 2, name: "Meditate", score: 8, archived: false, note: "Morning meditation", streakEnabled: true, allowSkip: false, weeklyBonus: true },
  { id: 3, name: "Read a book", score: 7, archived: false, streakEnabled: false, allowSkip: false, weeklyBonus: false },
  { id: 4, name: "Drink water", score: 5, archived: false, streakEnabled: true, allowSkip: true, weeklyBonus: false },
  { id: 5, name: "Eat healthy", score: 6, archived: false, streakEnabled: true, allowSkip: false, weeklyBonus: true },
  { id: 6, name: "Smoke", score: -10, archived: false, streakEnabled: false, allowSkip: false, weeklyBonus: false },
  { id: 7, name: "Drink alcohol", score: -8, archived: false, streakEnabled: false, allowSkip: false, weeklyBonus: false },
  { id: 8, name: "Eat junk food", score: -7, archived: false, streakEnabled: false, allowSkip: false, weeklyBonus: false },
  { id: 9, name: "Stay up late", score: -6, archived: false, streakEnabled: false, allowSkip: false, weeklyBonus: false },
  { id: 10, name: "Procrastinate", score: -5, archived: false, streakEnabled: false, allowSkip: false, weeklyBonus: false },
];
// Default contexts
export const defaultContexts: Context[] = [
  { id: 1, name: "Sick", color: "#ff6b6b", archived: false },
  { id: 2, name: "Tired", color: "#ffd93d", archived: false },
  { id: 3, name: "WFH", color: "#6c5ce7", archived: false },
];
// Default categories
export const defaultCategories: Category[] = [
  { id: 1, name: "Fitness" },
  { id: 2, name: "Work" },
  { id: 3, name: "Social" },
  { id: 4, name: "Hobby" },
  { id: 5, name: "Health" },
  { id: 6, name: "Screen Time" },
  { id: 7, name: "Impulses" },
  { id: 8, name: "Misc" },
];
